module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"placeholder":"{0} 输入"}}')
  delete Component.options._Ctor
}
